import React from 'react';
import { Flex, Typography, Steps } from 'antd';
import { WizardHeaderProps } from '../types';
import BackButton from '../../BackButton';

const WizardHeader: React.FC<WizardHeaderProps> = ({
  pageTitle,
  onBack,
  backButtonText,
  steps,
  currentStep,
  isMobile,
}) => {
  return (
    <Flex vertical gap="small">
      <BackButton
        onClick={onBack}
        text={backButtonText}
        icon={true}
        style={{ marginBottom: '8px', alignSelf: 'flex-start' }}
      />
      
      <Typography.Title level={2} style={{ textAlign: 'center', marginBottom: '16px' }}>
        {pageTitle}
      </Typography.Title>

      <Steps
        current={currentStep}
        items={steps.map(item => ({ 
          title: item.title,
          description: !isMobile ? item.description : undefined 
        }))}
        direction="horizontal"
        size={isMobile ? "small" : "default"}
        style={{ marginBottom: '24px', width: '100%' }}
      />
    </Flex>
  );
};

export default WizardHeader;